/*
 * Boekadoe — centrale analytics-laag
 * ------------------------------------------------------------
 * Leest de data-track-* attributen die op de productpagina-componenten
 * staan (Hero, Garantie, Social Proof, FAQ, Sticky balk) en stuurt op
 * basis daarvan events naar GA4 (gtag) en Meta (fbq).
 *
 * Verstuurt NOOIT de daadwerkelijke inhoud van een veld (naam, e-mail,
 * getypte FAQ-vraag) — alleen of een interactie heeft plaatsgevonden.
 *
 * Conventie op de HTML-kant:
 *   data-track="<event_naam>"
 *   data-track-step="<funnel_stap>"
 *   data-track-value="<niet-persoonlijke keuzewaarde>"
 *   data-track-field="<veldnaam>"
 *
 * GA4 krijgt alle events. Meta krijgt alleen events met directe
 * advertentie/retargeting-waarde — de rest is voor Meta ruis.
 */
(function () {
  'use strict';

  /* checkout_started ging hier eerder ook naar Meta (trackCustom), maar is
     geen Meta-standaardevent (geen advertentie-optimalisatie mogelijk) en
     de audience-overlap met InitiateCheckout is nagenoeg compleet (klik op
     deze CTA's leidt direct tot laden van /afrekenen, geen drop-off ertussen)
     — dus geen zinvolle Meta-toegevoegde waarde. Sinds 2026-10-09 alleen
     nog naar GA4, niet meer naar Meta. */
  var META_EVENTS = [];

  /* Deze 4 funnel-events worden GA4-wise uitsluitend server-side afgehandeld
     door checkout.boekadoe.nl (bevestigd door de developer: GA4 accepteert
     geen front-end→eigen-backend→GA4-relay op de manier die wij testten).
     Daarom hier bewust GEEN gtag()-call — alleen capiEvent() naar /api/track,
     zie sendEvent()-aanroepen met capi:true voor deze namen. */
  var BACKEND_ONLY_GA4_EVENTS = ['begin_checkout', 'view_item', 'add_shipping_info', 'add_payment_info'];

  function gaEvent(name, params) {
    if (BACKEND_ONLY_GA4_EVENTS.indexOf(name) !== -1) return;
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params || {});
    }
  }

  /* options.metaName: stuur naar een Meta-event (bv. 'InitiateCheckout',
     'Purchase') via fbq('track', ...). options.metaCustom: true stuurt
     diezelfde metaName via fbq('trackCustom', ...) i.p.v. 'track' — voor
     events die geen officieel Meta-standaardevent zijn (bv. 'AddShippingInfo',
     dat Meta niet kent maar wel bruikbaar is voor custom audiences/
     conversions). options.eventId: voor Meta-dedup tussen deze client-side
     call en een latere server-side CAPI-call van hetzelfde moment. */
  function fbEvent(name, params, options) {
    if (typeof window.fbq !== 'function') return;
    if (options && options.metaName) {
      var method = options.metaCustom ? 'trackCustom' : 'track';
      if (options.eventId) {
        window.fbq(method, options.metaName, params || {}, { eventID: options.eventId });
      } else {
        window.fbq(method, options.metaName, params || {});
      }
      return;
    }
    if (META_EVENTS.indexOf(name) === -1) return;
    window.fbq('trackCustom', name, params || {});
  }

  function cookie(cname) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + cname.replace(/([$?*|{}\[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  /* capiEvent: stuurt hetzelfde event ook naar checkout.boekadoe.nl/api/track
     — de bestaande server-side-tracking-route van checkout.boekadoe.nl,
     exact in het veldformaat dat daar al aan de andere kant verwacht wordt
     (zie server-side-capi-spec.md). Die backend hasht zelf de PII (e-mail
     etc.) voor Meta CAPI en stuurt door naar Meta/GA4. Alleen voor events
     met options.capi: true — Purchase loopt hier bewust NIET doorheen,
     want dat is server-truth via de PayPro-webhook. options.capiData mag
     PII bevatten (first_name, email, ...): die gaat alleen naar onze eigen
     backend, nooit naar gtag/fbq client-side. */
  function capiEvent(gaName, metaName, eventId, capiData) {
    if (typeof window.fetch !== 'function') return;
    var body = {
      event: metaName,
      data: Object.assign({ event: gaName, stepName: metaName }, capiData || {}),
      fbp: cookie('_fbp'),
      fbc: cookie('_fbc'),
      eventId: eventId,
      client_user_agent: navigator.userAgent,
      ga_event: gaName,
      ga_client_id: cookie('_ga'),
      ga_session_id: cookie('_ga_64LX1VRSG4')
    };
    window.fetch('https://checkout.boekadoe.nl/api/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })['catch'](function () {});
  }

  function sendEvent(name, params, options) {
    gaEvent(name, params);
    fbEvent(name, params, options);
    if (options && options.capi && options.metaName) {
      var eventId = options.eventId || (name + '_' + Date.now() + '_' + Math.random().toString(36).slice(2));
      capiEvent(name, options.metaName, eventId, options.capiData);
    }
  }

  /* ============================================================
     1) Klik-gebaseerde tracking: data-track + data-track-value/-step
     ============================================================ */
  document.addEventListener(
    'click',
    function (e) {
      var el = e.target.closest('[data-track]');
      if (!el) return;

      var name = el.getAttribute('data-track');

      // plan_selected heeft een dynamische waarde (checked-state) en
      // wordt hieronder apart via een 'change'-listener afgehandeld.
      if (name === 'plan_selected') return;

      var step = el.getAttribute('data-track-step');
      var value = el.getAttribute('data-track-value');

      var params = {};
      if (step) params.funnel_step = step;
      if (value) params.value_label = value;

      sendEvent(name, params);
    },
    true
  );

  /* ============================================================
     1b) customize_item — samengestelde configuratie-trigger.
     age_selected en gender_selected vuren hierboven (sectie 1) al los
     een GA4-event per klik. Het moment waarop BEIDE keuzes compleet
     zijn is zelf ook relevant (niet los per keuze) — GA4 custom event
     customize_item + Meta-standaardevent CustomizeProduct via
     fbq('track', ...) (geen trackCustom, CustomizeProduct is een
     officieel Meta-standaardevent). Vuurt maximaal één keer per
     pagina-load.
     ============================================================ */
  var configState = { age: null, gender: null };
  var configSent = false;

  document.addEventListener(
    'click',
    function (e) {
      var el = e.target.closest('[data-track="age_selected"], [data-track="gender_selected"]');
      if (!el) return;

      var name = el.getAttribute('data-track');
      var value = el.getAttribute('data-track-value');

      if (name === 'age_selected') configState.age = value;
      if (name === 'gender_selected') configState.gender = value;

      if (configSent || !configState.age || !configState.gender) return;
      configSent = true;

      sendEvent(
        'customize_item',
        {
          funnel_step: 'product_configuration',
          age_range: configState.age,
          gender_preference: configState.gender
        },
        { metaName: 'CustomizeProduct' }
      );
    },
    true
  );

  /* ============================================================
     2) Change-gebaseerde tracking voor de abonnement-toggle
        (plan_selected — waarde komt uit e.target.checked, niet uit
        een statisch data-track-value, zie ANALYTICS HOOK NEEDED-comment
        bij dit element in de Hero)
     ============================================================ */
  function planValue(el) {
    return el.type === 'checkbox'
      ? el.checked
        ? 'abonnement'
        : 'eenmalig'
      : el.value;
  }

  document.addEventListener(
    'change',
    function (e) {
      var el = e.target.closest('[data-track="plan_selected"]');
      if (!el) return;

      var step = el.getAttribute('data-track-step');
      sendEvent('plan_selected', {
        funnel_step: step,
        value_label: planValue(el)
      });
    },
    true
  );

  // De toggle heeft standaard al een stand (checked/unchecked) zonder dat
  // de bezoeker hem aanraakt. Zonder dit stuurt de change-listener nooit
  // een event voor wie de default gewoon laat staan. Stuur daarom bij
  // load de huidige stand als baseline; een latere 'change' overschrijft
  // deze met de nieuwe keuze.
  var planToggle = document.querySelector('[data-track="plan_selected"]');
  if (planToggle) {
    sendEvent('plan_selected', {
      funnel_step: planToggle.getAttribute('data-track-step'),
      value_label: planValue(planToggle)
    });
  }

  /* ============================================================
     3) Formulier-tracking: data-track op een <form> (bv. FAQ-vraag
        versturen) — nooit de inhoud van het formulier meesturen.
     ============================================================ */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target.closest('form[data-track]');
      if (!form) return;

      var name = form.getAttribute('data-track');
      var step = form.getAttribute('data-track-step');

      sendEvent(name, { funnel_step: step });
    },
    true
  );

  /* ============================================================
     4) Veld-tracking: data-track-field — meldt of een veld is
        gestart / voltooid, nooit de ingevoerde waarde zelf.
     ============================================================ */
  var startedFields = {};

  document.addEventListener(
    'focusin',
    function (e) {
      var el = e.target.closest('[data-track-field]');
      if (!el) return;

      var field = el.getAttribute('data-track-field');
      if (startedFields[field]) return;
      startedFields[field] = true;

      var step = el.getAttribute('data-track-step');
      sendEvent('field_started', { field_name: field, funnel_step: step });
    },
    true
  );

  document.addEventListener(
    'focusout',
    function (e) {
      var el = e.target.closest('[data-track-field]');
      if (!el) return;

      var hasValue = !!(el.value && el.value.trim().length > 0);
      if (!hasValue) return;

      var field = el.getAttribute('data-track-field');
      var step = el.getAttribute('data-track-step');
      sendEvent('field_completed', { field_name: field, funnel_step: step });
    },
    true
  );

  /* ============================================================
     5) cta_blocked_incomplete — dit kan niet via een statisch
        data-attribuut, want het is pas achteraf bekend of de klik
        geblokkeerd werd. De Hero's eigen validatiescript (functie V())
        zet in dat geval de class "is-mis" op het bijbehorende fieldset.
        Hier observeren we die class-wijziging en vuren dan het event.
     ============================================================ */
  var blockedFieldMap = {
    'bkd-deal-v-leeftijd': 'age',
    'bkd-deal-v-wie': 'gender'
  };

  Object.keys(blockedFieldMap).forEach(function (id) {
    var el = document.getElementById(id);
    if (!el) return;

    var wasBlocked = el.classList.contains('is-mis');

    var observer = new MutationObserver(function () {
      var isBlocked = el.classList.contains('is-mis');
      if (isBlocked && !wasBlocked) {
        sendEvent('cta_blocked_incomplete', {
          funnel_step: 'product_configuration',
          missing_field: blockedFieldMap[id]
        });
      }
      wasBlocked = isBlocked;
    });

    observer.observe(el, { attributes: true, attributeFilter: ['class'] });
  });

  /* Globaal beschikbaar maken voor pagina's die geen theme-Liquid draaien
     (bv. /afrekenen en /bedankt, Shopify Pages met eigen inline script) en
     dus niet rechtstreeks bij de functies hierboven kunnen, omdat die door
     deze IIFE afgeschermd zijn. Die pagina's roepen voortaan
     window.BoekadoeAnalytics.sendEvent(naam, params, { metaName, eventId })
     aan i.p.v. zelf gtag()/fbq() te dupliceren — met een lokale fallback
     voor het geval dit script onverhoopt niet geladen is. */
  window.BoekadoeAnalytics = { sendEvent: sendEvent };
})();
